import {styled} from '@mui/material'

export const SurveyDialogStyle = styled('div')(({theme}) => ({
  iframe: {
    borderStyle: 'hidden',
    minHeight: '80vh'
  }
}))
